import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=37506ac5&"
import script from "./SettingsMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=37506ac5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports